/**
 * Possible design spacing (gap/margin/padding)
 */
export const spacing = {
  /** 4 */
  xxs: 4,
  /** 8 */
  xs: 8,
  /** 12 */
  sm: 12,
  /** 16 */
  md: 16,
  /** 24 */
  lg: 24,
  /** 32 */
  xl: 32,
  /** 40 */
  '2xl': 40,
};
